import { Link } from 'react-router-dom';
import type { VideoItem } from '@/mocks/videos';
import { formatPlays } from '@/utils/videoUtils';

interface VideoCardProps {
  video: VideoItem;
  showDescription?: boolean;
}

export default function VideoCard({ video, showDescription = false }: VideoCardProps) {
  return (
    <Link
      to={`/detail/${video.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-all duration-300 cursor-pointer"
    >
      <div className="relative w-full aspect-video overflow-hidden bg-background-200">
        <img
          src={video.cover}
          alt={`${video.title}封面`}
          title={`${video.title} - 在线观看`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-transparent"></div>
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-primary-500 text-background-50 text-xs font-medium">
          {video.type}
        </span>
        <span className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-foreground-950/70 text-accent-300 text-xs font-semibold flex items-center gap-1">
          <i className="ri-star-fill text-accent-400"></i>
          {video.rating.toFixed(1)}
        </span>
        <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded-md bg-foreground-950/75 text-background-100 text-xs">
          {video.duration}
        </span>
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <span className="w-12 h-12 rounded-full bg-primary-500/95 flex items-center justify-center">
            <i className="ri-play-fill text-background-50 text-2xl"></i>
          </span>
        </div>
      </div>

      <div className="p-3 md:p-4">
        <h3 className="text-sm md:text-base font-semibold text-foreground-950 line-clamp-1 group-hover:text-primary-700 transition-colors">
          {video.title}
        </h3>
        {showDescription ? (
          <p className="mt-1.5 text-xs md:text-sm text-foreground-500 line-clamp-2 leading-relaxed">
            {video.description}
          </p>
        ) : (
          <p className="mt-1.5 text-xs md:text-sm text-foreground-500 line-clamp-1">
            {video.subtitle}
          </p>
        )}
        <div className="mt-2 flex items-center flex-wrap gap-x-3 gap-y-1 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line"></i>
            {video.year}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-map-pin-line"></i>
            {video.region}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-fire-line text-accent-500"></i>
            {formatPlays(video.plays)}
          </span>
        </div>
      </div>
    </Link>
  );
}